import {EventLocation} from "../../../types/Event";
import {OptionalSelectedItemsData} from "../../../components/EntitySelector/EntitySelector.types";
import {Exhibit} from "../../../types/Exhibit";
import {Facility} from "../../../types/Facility";
import {ZoneListing} from "../../../types/Zone";
import {Place} from "../../../types/Place";

export function createSelectedLocationItem(location: EventLocation | null): OptionalSelectedItemsData {
  if (!location) return {};

  let item;

  switch (location.type) {
    case 'exhibit':
      item = {
        id: location.id,
        name: location.name,
        image: location.image,
        zone: {
          site: {
            name: location.site.name
          }
        }
      } as Exhibit
      break;
    case 'facility':
      item = {
        id: location.id,
        name: location.name,
        image: location.image,
        zone: {
          site: {
            name: location.site.name
          }
        }
      } as Facility
      break;
    case 'zone':
      item = {
        id: location.id,
        name: location.name,
        site: {
          name: location.site.name
        }
      } as ZoneListing
      break;
    case 'place':
      item = {
        id: location.id,
        name: location.name,
        address: location.address,
      } as Place
      break;
  }

  return {
    [location.type]: [item]
  }
}